<section class="censo-page">
  <div class="censo-shell">
    <header class="censo-hero">
      <div class="hero-copy">
        <span class="eyebrow">Estatísticas dos Recenseados</span>
        <h1>{{titulo}}</h1>
        <p>Panorama consolidado do Censo Digital com acompanhamento de conferência, finalização, inconsistências e adesão por secretaria.</p>
      </div>

      <div class="hero-score" aria-label="Percentual concluído">
        <div class="score-ring">
          <span>{{percentualConclusao()}}</span>
        </div>
        <div class="score-content">
          <span>Concluído</span>
          <strong>Versão do APP: {{versaoApp || '...'}}</strong>
        </div>
      </div>
    </header>

    <div class="summary-grid">
      <article class="metric-card metric-card-accent">
        <span class="metric-label">Finalizados</span>
        <strong>{{quantidade(concluidos)}}</strong>
        <small>{{percentualConclusao()}} do contingente</small>
      </article>

      <article class="metric-card">
        <span class="metric-label">Para Conferir</span>
        <strong>{{quantidade(aguardando)}}</strong>
        <small>Em análise</small>
      </article>

      <article class="metric-card">
        <span class="metric-label">Não enviados</span>
        <strong>{{quantidade(pendentes)}}</strong>
        <small>Não manifestantes: {{percentualNaoManifestantes()}}</small>
      </article>

      <article class="metric-card metric-card-alert">
        <span class="metric-label">Inconsistentes</span>
        <strong>{{quantidade(inconsistentes)}}</strong>
        <small>{{percentualInconsistentes()}} do contingente</small>
      </article>

      <article class="metric-card metric-card-proof">
        <span class="metric-label">Tiraram Comprovante</span>
        <strong>{{quantidade(comprovantes)}}</strong>
        <small>Com registro emitido</small>
      </article>
    </div>

    <section class="overview-panel">
      <div class="completion-panel">
        <div class="panel-heading">
          <span>Leitura geral</span>
          <strong>{{quantidade(unidades)}} registros</strong>
        </div>

        <div class="progress-block">
          <div class="progress-row">
            <span>Concluído</span>
            <strong>{{percentualConclusao()}}</strong>
          </div>
          <div class="progress-track">
            <div class="progress-fill progress-fill-done" [style.width]="percentualValor(quantidade(concluidos), quantidade(unidades)) + '%'"></div>
          </div>
        </div>

        <div class="progress-block">
          <div class="progress-row">
            <span>Inconsistências</span>
            <strong>{{percentualInconsistentes()}}</strong>
          </div>
          <div class="progress-track">
            <div class="progress-fill progress-fill-alert" [style.width]="percentualValor(quantidade(inconsistentes), quantidade(unidades)) + '%'"></div>
          </div>
        </div>

        <div class="progress-block">
          <div class="progress-row">
            <span>Não Manifestantes</span>
            <strong>{{percentualNaoManifestantes()}}</strong>
          </div>
          <div class="progress-track">
            <div class="progress-fill progress-fill-muted" [style.width]="percentualNaoManifestantesValor() + '%'"></div>
          </div>
        </div>

        <div class="group-list">
          <div class="group-item">
            <span>SEMED</span>
            <strong>{{semedFeito}}/{{quantidade(semed)}}</strong>
            <small>{{percentual(semedFeito, quantidade(semed))}}</small>
          </div>

          <div class="group-item">
            <span>SEMUSA</span>
            <strong>{{semusaFeito}}/{{quantidade(semusa)}}</strong>
            <small>{{percentual(semusaFeito, quantidade(semusa))}}</small>
          </div>

          <div class="group-item">
            <span>OUTROS</span>
            <strong>{{outrosFeito}}/{{quantidade(outros)}}</strong>
            <small>{{percentual(outrosFeito, quantidade(outros))}}</small>
          </div>
        </div>
      </div>

      <div class="secretarias-panel">
        <div class="panel-heading">
          <span>Secretarias</span>
          <div class="legend">
            <span><i class="legend-dot legend-dot-review"></i>Em análise</span>
            <span><i class="legend-dot legend-dot-alert"></i>Inconsistentes</span>
          </div>
        </div>

        <div class="secretarias-list">
          <article class="secretaria-row" *ngFor="let sec of secretarias">
            <div class="secretaria-main">
              <strong>{{sec.nome}}</strong>
              <span>{{sec.prontos}}/{{sec.quantidade}} ({{percentual(sec.prontos, sec.quantidade)}})</span>
            </div>

            <div class="secretaria-stats">
              <span class="stat-review">{{sec.aguardando}}</span>
              <span class="stat-alert">{{sec.inconsistentes}}</span>
            </div>

            <div class="secretaria-actions">
              <span *ngIf="sec.prontos==sec.quantidade" class="status-complete" tooltipPosition="left" pTooltip="Secretaria concluiu todo o contingente">
                <i class="pi pi-star"></i>
              </span>

              <button type="button" class="icon-action" tooltipPosition="top" pTooltip="Lista dos que não realizaram o censo" (click)="listarNaoFez(sec)">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>

    <p-tabView styleClass="censo-tabs">
      <p-tabPanel header="Quantitativos">
        <div class="tab-surface">
          <div class="chart-frame">
            <div id="pizza"></div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Produtividade">
        <div class="tab-surface">
          <div class="chart-frame">
            <div id="produtividade"></div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Produção Diária">
        <div class="tab-surface">
          <div class="chart-frame">
            <div id="porDia"></div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Por Versão">
        <div class="tab-surface">
          <div class="chart-frame">
            <div id="porVersao"></div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Avaliações">
        <div class="tab-surface">
          <div class="table-frame">
            <p-table *ngIf="avaliacoes && avaliacoes.length" [value]="avaliacoes" [rows]="10" styleClass="censo-table">
              <ng-template pTemplate="header">
                <tr>
                  <th>Censo</th>
                  <th>Versão</th>
                  <th>Nota Média</th>
                  <th>Qtde. Votos</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-t>
                <tr>
                  <td>{{t.censo}}</td>
                  <td>{{t.versao}}</td>
                  <td>{{t.media}}</td>
                  <td>{{t.quantidade}}</td>
                </tr>
              </ng-template>
            </p-table>

            <div *ngIf="!avaliacoes || !avaliacoes.length" class="empty-state">
              Nenhuma avaliação encontrada.
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Comentários">
        <div class="tab-surface comments-surface">
          <div class="comments-gate">
            <input type="password" pPassword [(ngModel)]="senhaD" placeholder="Senha" />
            <button pButton type="button" (click)="esenha()" label="OK" class="ui-button-rounded ui-button-success"></button>
          </div>

          <div *ngIf="!mostrarComentarios" class="empty-state">
            Entre com a senha.
          </div>

          <div *ngIf="comentarios && mostrarComentarios" class="comments-grid">
            <article class="comment-card" *ngFor="let co of comentarios">
              <div class="comment-head">
                <strong>{{co.nome}}</strong>
                <span>Nota: {{co.nota}}</span>
              </div>

              <div class="comment-body">
                {{co.comentario}}
              </div>

              <div class="comment-version">
                Versão: {{co.versao}}
              </div>
            </article>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</section>
